import { useCallback, useRef } from 'react';

export default function useThrottledRealtimeRefresh({
  refresh,
  throttleMs = 1000,
}) {
  const dirtyRef = useRef(false);
  const inFlightRef = useRef(false);
  const timerRef = useRef(null);

  const signalCountRef = useRef(0);
  const refreshCountRef = useRef(0);
  const lastRefreshAtRef = useRef(0);

  const schedule = useCallback(() => {
    if (timerRef.current) return;

    timerRef.current = setTimeout(() => {
      timerRef.current = null;

      if (!dirtyRef.current) return;

      if (inFlightRef.current) {
        schedule(); // trailing
        return;
      }

      dirtyRef.current = false;
      inFlightRef.current = true;

      refreshCountRef.current += 1;

      const now = performance.now();
      const delta = lastRefreshAtRef.current
        ? (now - lastRefreshAtRef.current).toFixed(1)
        : 'N/A';
      lastRefreshAtRef.current = now;

      console.log(
        `[RT] refresh#${refreshCountRef.current} delta=${delta}ms throttleMs=${throttleMs} signals=${signalCountRef.current}`,
      );

      try {
        refresh();
      } finally {
        inFlightRef.current = false;

        if (dirtyRef.current) schedule();
      }
    }, throttleMs);
  }, [refresh, throttleMs]);

  const signal = useCallback(() => {
    signalCountRef.current += 1;
    dirtyRef.current = true;
    schedule();
  }, [schedule]);

  return { signal };
}
